import { FunctionComponent } from "react";
import BasicModal from "@components/core/modals/BasicModal";
import { useTranslation } from "react-i18next";
import imageJSE from "@static/core/img/jse_transparent.png";
import { ModelMailTypes } from "@/type/core/models/models.types";
import parse from "html-react-parser";

interface PreviewMailModalProps {
  visible: boolean;
  onCancel: () => void;
  sender: string;
  subject: string;
  previewMail?: string;
  mailType?: ModelMailTypes;
  message?: string;
  signature?: string;
  className?: string;
}

const PreviewMailModal: FunctionComponent<PreviewMailModalProps> = ({
  visible,
  onCancel,
  sender,
  subject,
  previewMail,
  mailType,
  message,
  signature,
  className = "",
}) => {
  const { t } = useTranslation();

  const jesignexpert = "jesignexpert.com";

  const invitationPreview = () => {
    return (
      <div className="bg-none">
        <table className="w-100 font-arial">
          <tbody>
            <tr>
              <td align="center">
                <div className="d-block text-right mr-8">
                  <img
                    data-imagetype="External"
                    width={190}
                    src={imageJSE}
                    alt=""
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="mail-preview-delete-container">
                <p className="white-space-pre-line">
                  {!message || message.length === 0
                    ? "Bonjour,\n\nVous êtes invités à signer les documents sur la plateforme jesignexpert.com"
                    : message}
                </p>
              </td>
            </tr>
            <tr>
              <td align="center" className="pt-40">
                <table className="consult-document-table">
                  <tbody>
                    <tr>
                      <td align="center" className="bg-primary">
                        <a
                          href=""
                          target="_blank"
                          className="consult-document-and-sign-link"
                        >
                          Consulter les&nbsp; documents et signer
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" className="font-size-14 px-16 pt-8">
                        <b>
                          Pour signer, veuillez vous munir de votre téléphone
                          mobile.
                        </b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td align="center" className="font-size-20 pt-32">
                {parse(signature ?? "")}
              </td>
            </tr>
            <tr>
              <td>
                <div className="mt-10">
                  <div className="mail-preview-spacer">&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr>
              <td align="center" className="font-size-14">
                <div className="mail-preview-content-container">
                  <div className="subcontainer">
                    <span className="w-100">
                      {
                        "Vous êtes invité à signer des documents sur la plateforme de signature électronique de la profession comptable : "
                      }
                      <a
                        href="http://jesignexpert.com"
                        className="text-primary"
                      >
                        {jesignexpert}
                      </a>
                      {". Plus besoin d’imprimer pour signer, "}
                      <a
                        href="http://jesignexpert.com"
                        className="text-primary"
                      >
                        {jesignexpert}
                      </a>{" "}
                      est conforme au règlement européen eIDAS 910/2014 du 23
                      juillet 2014 et vous permet de signer vos documents PDF en
                      toute sécurité, en seulement quelques clics.
                    </span>
                    <span className="w-100 white-space-pre-line">
                      {
                        "\nNotre plateforme, certifiée LCP, garantit que seuls les experts-comptables inscrits au tableau de l’ordre ou leurs collaborateurs ayant délégation peuvent utiliser "
                      }
                      <a
                        href="http://jesignexpert.com"
                        className="text-primary"
                      >
                        {jesignexpert}
                      </a>
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const endOfTransactionPreview = () => {
    return (
      <div className="bg-none">
        <table className="font-family-arial w-100">
          <tbody>
            <tr>
              <td align="center">
                <div className="d-block text-right mr-8">
                  <img
                    data-imagetype="External"
                    width={190}
                    src={imageJSE}
                    alt=""
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td align="center" className="mail-preview-delete-container">
                <p className="white-space-pre-line">
                  {!message || message.length === 0
                    ? "Bonjour,\n\nVous pouvez télécharger les documents signés en cliquant sur le bouton ci-dessous."
                    : message}
                </p>
                <p className="danger">
                  <b>Attention</b> : Les documents seront supprimés au bout de
                  60 jours calendaires. Pensez à télécharger et à stocker
                  systématiquement vos documents signés dans vos systèmes
                  d’information (GED, système d’archivage…).
                </p>
              </td>
            </tr>
            <tr>
              <td align="center" className="pt-40">
                <table className="consult-document-table">
                  <tbody>
                    <tr>
                      <td align="center" className="bg-primary">
                        <a
                          href=""
                          target="_blank"
                          className="consult-document-and-sign-link"
                        >
                          Télécharger les documents
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td align="center" className="mail-preview-delete-container">
                <p>
                  Attention : Ce lien sécurisé est personnel et valable 7 jours.
                  Veuillez ne pas le communiquer à un tiers.
                </p>
              </td>
            </tr>
            <tr>
              <td align="center" className="font-size-20 pt-32">
                {parse(signature ?? "")}
              </td>
            </tr>
            <tr>
              <td>
                <div className="mt-10">
                  <div className="mail-preview-spacer">&nbsp;</div>
                </div>
              </td>
            </tr>
            <tr>
              <td align="center" className="font-size-14">
                <div className="mail-preview-content-container">
                  <div className="subcontainer">
                    <span className="w-100">
                      <a
                        href="http://jesignexpert.com"
                        target="_blank"
                        rel="noreferrer"
                        className="text-primary"
                      >
                        {jesignexpert}
                      </a>{" "}
                      est la plateforme de signature pour la profession
                      comptable.
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <BasicModal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      title={
        <>
          <b>{t("signature.accordion.parametersForm.preview.modal.sender")}</b>
          {sender}
          <br />
          <b>
            {t(
              "signature.accordion.parametersForm.preview.modal.subject.label",
            )}
          </b>
          {subject}
        </>
      }
      className={`app-modal-preview-mail modal-xl ${className}`}
    >
      <>
        {previewMail
          ? parse(previewMail)
          : mailType === "invitation"
            ? invitationPreview()
            : endOfTransactionPreview()}
      </>
    </BasicModal>
  );
};

export default PreviewMailModal;
